export const INPUT_CLASSNAMES = {
  default:
    'placeholder:opacity-0 w-full py-2 px-2.5 text-secondary border border-mediumBlue rounded-xl placeholder:text-gray1',
  error: 'border-red text-red',
  disabled: 'bg-gray',
};
